export const WARSAW = { lat: 52.237049, lng: 21.017532 };
export const ACTIVE_MARKER =
    "data:image/svg+xml;charset=utf8,%3Csvg width='10' height='10' xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Ctitle%3ELayer 1%3C/title%3E%3Cellipse stroke='%23fff' ry='5.28889' rx='5.41481' id='svg_1' cy='4.98518' cx='5.01111' fill='%23fdb913'/%3E%3C/g%3E%3C/svg%3E";
export const INACTIVE_MARKER =
    "data:image/svg+xml;charset=utf8,%3Csvg width='10' height='10' xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Ctitle%3ELayer 1%3C/title%3E%3Cellipse stroke='%23fff' ry='5.28889' rx='5.41481' id='svg_1' cy='4.98518' cx='5.01111' fill='%23007dc5'/%3E%3C/g%3E%3C/svg%3E";
export const PIN =
    "data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg width='22px' height='40px' viewBox='0 0 22 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Strona_produktowa_Sawa' transform='translate(-1389.000000, -3930.000000)'%3E%3Cg id='google_maps_pin' transform='translate(1389.000000, 3930.000000)'%3E%3Cpath d='M11,0.5 C13.8994949,0.5 16.5244949,1.67525253 18.4246212,3.5753788 C20.3247475,5.47550506 21.5,8.10050506 21.5,11 C21.5,13.1439443 20.8575708,15.1378752 19.7495688,16.8070372 C18.0857774,19.412925 14.3659648,25.4734267 13.1606259,28.9962495 C12.1985375,31.808128 11.5441681,35.6153179 11.1969512,38.01314 L11.1969512,38.01314 L11.1969512,39.5 L10.7534547,38.01314 C10.4062378,35.6153179 9.7518683,31.808128 8.78977997,28.9962495 C7.57569869,25.4478756 3.86576741,19.3569132 2.45784347,17.1089014 C1.21884358,15.3677757 0.5,13.2678178 0.5,11 C0.5,8.10050506 1.67525253,5.47550506 3.5753788,3.5753788 C5.47550506,1.67525253 8.10050506,0.5 11,0.5 Z' id='pin' stroke='%23002C5C' fill='%23FCC94D'%3E%3C/path%3E%3Cpath d='M11,16 C13.209139,16 15,14.209139 15,12 C15,9.790861 13.209139,8 11,8 C8.790861,8 7,9.790861 7,12 C7,14.209139 8.790861,16 11,16 Z' id='circle' fill='%23002C5C'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E";
export const MARKER_CLUSTERER_ICON_PATH =
    "/content/themes/warexpo/assets/scripts/map/images/m";
export const ACTIVE = "active";
export const INACTIVE = "inactive";
export const DISTANCE_OPTIONS = [
    { label: "500m", distanceInKm: 0.5 },
    { label: "700m", distanceInKm: 0.7 },
    { label: "1000m", distanceInKm: 1 }
];
export const CATEGORIES = [
    "Smart Citylight",
    "LED space",
    "Słupy Tradycyjne",
    "Słupy podświetlane"
];
export const GROUPS = {
    "Krakowskie Przedmieście": [
        ["52.2394598", "21.0172849"],
        ["52.239894", "21.016684"],
        ["52.241375", "21.015768"],
        ["52.243998", "21.014071"],
        ["52.245207", "21.0138"],
        ["52.2331612", "21.0108976"],
        ["52.2330278", "21.0113793"],
        ["52.2331099", "21.0118379"],
        ["52.24572", "21.01404"]
    ],
    "Trakt Królewski": [
        ["52.22542", "20.992561"],
        ["52.227733", "21.000711"],
        ["52.226937", "20.999228"],
        ["52.2309", "21.0179"],
        ["52.230396", "21.016658"],
        ["52.231079", "21.018634"],
        ["52.230565", "21.014214"],
        ["52.229009", "21.007191"],
        ["52.228285", "21.003461"],
        ["52.23248", "21.023217"],
        ["52.229361", "21.008892"],
        ["52.226067", "21.014368"],
        ["52.234118", "20.99819"],
        ["52.234531", "20.998026"],
        ["52.239711", "20.99585"],
        ["52.244682", "20.991513"],
        ["52.244083", "20.991141"],
        ["52.250826", "20.985321"],
        ["52.213939", "21.02118"],
        ["52.236232", "21.008125"],
        ["52.237127", "21.007594"],
        ["52.224694", "21.015205"],
        ["52.225495", "21.014705"],
        ["52.227072", "21.013741"],
        ["52.224983", "21.014194"],
        ["52.228039", "21.013228"],
        ["52.228", "21.012516"],
        ["52.235578", "21.008559"],
        ["52.229173", "21.007995"],
        ["52.254472", "20.983371"],
        ["52.235992", "20.996672"],
        ["52.253462", "20.983037"],
        ["52.243055", "20.996273"],
        ["52.242035", "21.003433"],
        ["52.238152", "21.006894"],
        ["52.22872", "21.007385"],
        ["52.229064", "21.009225"],
        ["52.241822", "20.994041"],
        ["52.242758", "20.992333"],
        ["52.225632", "20.990851"],
        ["52.2257469", "20.9941419"],
        ["52.233119", "21.026241"],
        ["52.232875", "21.025287"],
        ["52.232354", "21.024691"],
        ["52.230263", "21.012308"],
        ["52.238139", "21.006274"],
        ["52.230611", "21.016562"],
        ["52.23154", "21.010948"],
        ["52.234008", "21.009483"],
        ["52.230784", "21.011417"],
        ["52.232732", "21.01021"],
        ["52.228983", "21.005606"],
        ["52.234986", "21.007922"],
        ["52.223753", "21.015788"],
        ["52.22697", "21.013127"],
        ["52.215986", "21.020435"],
        ["52.229732", "21.009851"],
        ["52.228712", "21.0058725"],
        ["52.230785", "21.015171"],
        ["52.232264", "21.01051"],
        ["52.23297", "21.010077"],
        ["52.224254", "21.015484"],
        ["52.233733", "21.009631"],
        ["52.233586", "21.009725"],
        ["52.228652", "21.0121"],
        ["52.236394", "21.008022"],
        ["52.235374", "21.007935"],
        ["52.2248326", "21.015037"],
        ["52.226799", "21.013901"],
        ["52.228774", "21.01276"],
        ["52.230843", "21.010743"],
        ["52.2363", "21.007427"],
        ["52.247634", "20.9882537"],
        ["52.229903", "21.013505"],
        ["52.23175", "21.010817"],
        ["52.230997", "21.011279"],
        ["52.24086", "20.994871"],
        ["52.227868", "21.013325"],
        ["52.2450068", "20.9911987"],
        ["52.22773", "21.00071"],
        ["52.22574", "20.99414"],
        ["52.22737", "20.99917"],
        ["52.226807", "20.998392"],
        ["52.227062", "20.997906"]
    ],
    "Metro Świętokrzyska": [["52.2352128", "21.0084647"]],
    "Wiaty przystankowe": [
        ["52.2913725", "20.9308556"], //Młociny
        ["52.2992235", "21.0425198"], //Bródno 1
        ["52.3001883", "21.0418823"], //Bródno 6
        ["52.3002851", "21.0418751"], //Bródno 5
        ["52.3003864", "21.0418561"], //Bródno 4
        ["52.2319125", "20.9935185"], //Norblin 1
        ["52.2320362", "20.993276"], //Norblin 3
        ["52.2321396", "20.9932477"], //Norblin 4
        ["52.2315441", "20.9925411"], //Norblin 5
        ["52.2323246", "20.9924057"], //Norblin 6
        ["52.1290066", "21.0685828"], //Kabaty 1
        ["52.1289465", "21.0684267"], //Kabaty 2
        ["52.1293384", "21.0682716"], //Kabaty 3
        ["52.1292824", "21.0681077"], //Kabaty 4
        ["52.129207", "21.067938"], //Kabaty 5
        ["52.1288896", "21.0682511"], //Kabaty 6
        ["52.234808", "21.0071132"], //Metro świętokrzyska 3
        ["52.2351143", "21.0074646"] //Metro świętokrzyska 3
    ]
};
export const GOOGLE_MAP_STYLES = [
    {
        featureType: "landscape",
        elementType: "labels",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "transit",
        elementType: "labels",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "poi",
        elementType: "labels",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "water",
        elementType: "labels",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "road",
        elementType: "labels.icon",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        stylers: [
            {
                hue: "#00aaff"
            },
            {
                saturation: -100
            },
            {
                gamma: 2.15
            },
            {
                lightness: 12
            }
        ]
    },
    {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [
            {
                visibility: "on"
            },
            {
                lightness: 24
            }
        ]
    },
    {
        featureType: "road",
        elementType: "geometry",
        stylers: [
            {
                lightness: 57
            }
        ]
    }
];
